/**
 * Group prepared-drop bulk operations by country (global merged list).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { PreparedDrop } from '@/features/smswiser-campaigns/types/workspace.types';

export function groupItemsByCountryKey(
  items: Array<{ id: string; wiserId: number }>,
  drops: PreparedDrop[],
): Map<string, Array<{ id: string; wiserId: number }>> {
  const dropById = new Map(drops.map((d) => [d.id, d]));
  const map = new Map<string, Array<{ id: string; wiserId: number }>>();
  for (const item of items) {
    const d = dropById.get(item.id);
    if (!d?.countryKey) continue;
    const list = map.get(d.countryKey) ?? [];
    list.push(item);
    map.set(d.countryKey, list);
  }
  return map;
}

export function groupIdsByCountryKey(ids: string[], drops: PreparedDrop[]): Map<string, string[]> {
  const dropById = new Map(drops.map((d) => [d.id, d]));
  const map = new Map<string, string[]>();
  for (const id of ids) {
    const d = dropById.get(id);
    if (!d?.countryKey) continue;
    const list = map.get(d.countryKey) ?? [];
    list.push(id);
    map.set(d.countryKey, list);
  }
  return map;
}

/** Drafts grouped for per-(country,wiser) bulk-send streams. */
export function groupDraftIdsForBulkSend(drafts: PreparedDrop[]): Array<{
  countryKey: string;
  wiserId: number;
  ids: string[];
}> {
  const key = (ck: string, wid: number) => `${ck}::${wid}`;
  const map = new Map<string, { countryKey: string; wiserId: number; ids: string[] }>();
  for (const d of drafts) {
    if (d.status !== 'DRAFT' || !d.countryKey) continue;
    const k = key(d.countryKey, d.wiserId);
    const cur = map.get(k) ?? { countryKey: d.countryKey, wiserId: d.wiserId, ids: [] as string[] };
    cur.ids.push(d.id);
    map.set(k, cur);
  }
  return [...map.values()];
}
